import { render, staticRenderFns } from "./MinorSidebar.vue?vue&type=template&id=21118562&scoped=true"
import script from "./MinorSidebar.vue?vue&type=script&lang=js"
export * from "./MinorSidebar.vue?vue&type=script&lang=js"
import style0 from "./MinorSidebar.vue?vue&type=style&index=0&id=21118562&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21118562",
  null
  
)

export default component.exports